const Styles = {
  container: {
    width: '80%'
  },
  paperContainer: {
    width: '100%',
    marginBottom: 15,
    padding: 10,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10
  },
  text: {
    margin: 0
  },
  iconText: {
    fontSize: 24,
    marginRight: 15
  },
  icon: {
    fontSize: 24
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/containers/LaundryBookingItems/styles.js